import React, { useState } from "react";
import { useDispatch } from "react-redux";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import IconButton from "@mui/material/IconButton";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { JOB_SEEKER_STATUS, JOB_SEEKER_STATUS_TEXT } from "../../helpers/constant/coreConstant";
import { updateJobSeekerStatus } from "../../state/jobSeeker/jobSeekerSlice";
import JobSeekerService from "../../services/jobSeeker.service";
import toast from "react-hot-toast";

const ITEM_HEIGHT = 48;

const JsMenuAction = ({ jobSeeker }) => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const { id, status } = jobSeeker || {};
  const targetStatus = status === JOB_SEEKER_STATUS.ACTIVE ? JOB_SEEKER_STATUS.INACTIVE : JOB_SEEKER_STATUS.ACTIVE;

  const [anchorEl, setAnchorEl] = useState(null);
  const handleMenuClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleStatusChange = () => {
    dispatch(updateJobSeekerStatus({ id: id, status: targetStatus }));
    handleMenuClose();
  };

  const handleForceLogin = async () => {
    try {
      setLoading(true);
      const response = await JobSeekerService.forceLogin(id);
      if (response?.status && response?.data?.redirectUrl) {
        const token = response.data.redirectUrl;
        const baseUrl = process.env.REACT_APP_TALENT_USER_ACCOUNT;
        const fullUrl = `${baseUrl}/${token}`;
        window.open(fullUrl, "_blank");
        toast.success("Redirecting to user account...");
      } else {
        toast.error(response?.message || "Failed to generate impersonation key");
      }
    } catch (error) {
      console.error("Impersonation failed:", error);
      toast.error(error?.response?.data?.message || "Impersonation failed");
    } finally {
      setLoading(false);
      handleMenuClose();
    }
  };

  const open = Boolean(anchorEl);
  return (
    <>
      <IconButton aria-label="more" id="long-button" aria-controls={open ? "long-menu" : undefined} aria-expanded={open ? "true" : undefined} aria-haspopup="true" onClick={handleMenuClick}>
        <MoreVertIcon />
      </IconButton>
      <Menu
        id="long-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleMenuClose}
        PaperProps={{
          style: {
            maxHeight: ITEM_HEIGHT * 4.5,
            width: "20ch",
          },
        }}
      >
        <MenuItem onClick={handleForceLogin} disabled={loading}>
          {loading ? "Please wait..." : "Force Login"}
        </MenuItem>
        <MenuItem onClick={handleStatusChange}>{JOB_SEEKER_STATUS_TEXT[targetStatus]}</MenuItem>
      </Menu>
    </>
  );
};

export default JsMenuAction;
